<template>
<div>
	<div v-if="error > 0" class="alert alert-danger fade in"
		style="margin-top: 25px">
		<span v-html="$t('misc.errorDataLoading')"></span><br> <span
			v-if="error == 1">{{$t('misc.errorServerResponse', {status: status})}}</span> 
			<span v-else>{{$t('misc.errorNoServerResponse')}}</span>
	</div>

	<div v-else-if="loading"
		class="text-center" style="margin-top: 25px">
		<strong> <i class="fa fa-refresh fa-spin" />
			{{$t('misc.waitLoading')}}
		</strong>
	</div>

	<select v-else
		class="selectpicker form-control inputElement" data-live-search="true" :id="'select-'+id">
		<option v-for="option in options" :key="'option-'+option.id"
			:value="option.id" v-if="!option.hasOwnProperty('category')">{{option.value}}</option>
		<optgroup :label="option.category" v-else>
			<option v-for="item in option.options" :key="'option-'+item.id"
				:value="item.id">{{item.value}}</option>
		</optgroup>
	</select>
</div>
</template>

<script>
import 'bootstrap-select/dist/js/bootstrap-select.min'
import 'bootstrap-select/dist/css/bootstrap-select.min.css'
export default {
  name: "DropdownInputScope",
  data() {
    return {
      options: {},
      loading: true,
      error: 0,
      status: 0
    };
  },
  props: ["value", "id", "get", "scope"],
  created() {
	this.loading = true;
	this.error = 0;
    axios
      .get(this.get)
      .then(response => {
        this.options = response.data;
        var check = this.value;
    	this.loading = false;
        this.$nextTick(() => {
          var select = -1;
          var context = this;
          if(check !== null) {
              $("#select-" + this.id + " option").each(function() {
                  if (this.text == check) {
                    select = this.value;
                    return false;
                  }           
                }); 
          }
          if(select !== -1){
          	$("#select-" + this.id).val(select);
          } else {
        	$("#select-" + this.id + " option").first().attr("selected", "selected");
          }
          
          $("#select-" + this.id + " option").each(function() {
        	 if(this.text == "noValue"){
             	$(this).text(context.$t('misc.noValue'));  
        	 } else {
            	 $(this).text(context.$t(context.scope + "."+this.text));    
        	 }
           }); 
          
          $("#select-" + this.id + " optgroup").each(function() {
         	 var $this = $(this);
         	 $this.prop('label', context.$t(context.scope + ".categories."+$this.prop('label')));       
            }); 
          $("#select-" + this.id).selectpicker();
        });
      })
      .catch(error => {
          if (error.response) {
  	    	this.error = 1;
	    	this.status = error.response.status;
          } else if (error.request) {
	  	    this.error = 2;
          } 
    });
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/input/DropdownInputScope.vue